import { mapGetters } from 'vuex';
import courseMixins from '@/mixins/templates/course';
import CommonMixin from '@/mixins/templates/common';
import maxModule from '@/components/content-v2/modals/max-module';

export default {
  components: {
    maxModule
  },
  mixins: [courseMixins, CommonMixin],
  data() {
    return {
      isOpenModalMaxModule: false
    };
  },
  computed: {
    ...mapGetters({
      getterCourse: 'plataforma/newContent/getterCourse'
    })
  }
};
